import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import FeatureFlags from '../../util/featureFlags';

const showWebNavCart = () => {
  window.dispatchEvent(new CustomEvent('OPEN_MODAL_EVENT', { detail: 'CART' }));
};

const HeaderCart = ({ cartSize, onCart, classNames }) => {
  const handleCartClick = FeatureFlags.get('publicWebNavCartModal') ? showWebNavCart : onCart;
  return (
    <div className={cx('website-title__cart', classNames)}>
      {cartSize > 0 && FeatureFlags.get('persistentCart') && (
        <a role="button" className="cart-modal-link with-icon" onClick={handleCartClick}>
          {cartSize > 0 && <span className="badge">{cartSize}</span>}
          <i className="zolaicon zolaicon-cart" />
        </a>
      )}
    </div>
  );
};

HeaderCart.propTypes = {
  cartSize: PropTypes.number,
  onCart: PropTypes.func,
  classNames: PropTypes.string,
};

export default HeaderCart;



// WEBPACK FOOTER //
// ./src/components/PublicWebsite/HeaderCart.jsx